import { Injectable } from "@angular/core";
import { Subject } from 'rxjs';
import * as io from 'socket.io-client';
import { Router } from '@angular/router';

import * as CryptoJS from 'crypto-js';

import { environment } from 'src/environments/environment';

export class requetsGlobals {
    token: string;
    params?: Object;
    data?: Object;
    client?: boolean
}
export class responseGlobals {
    token: string;
    status?: number;
    message?: string;
    data?: any;
}
@Injectable()
export class IoGlobals {

    // public BASE_API_URL: string = window['PATH'];

    public BASE_API_URL: string = environment.domain;

    public socket: any;

    private response = new Subject<responseGlobals>();

    public result = this.response.asObservable();

    public logo: any = '';

    public link: string = '';

    public branch_code: string = '';

    constructor(
        public router: Router
    ) {

    }

    public ini() {
        if (!this.socket && this.socket == null) {
            this.socket = io(this.BASE_API_URL, { rejectUnauthorized: false });

            console.log(this.BASE_API_URL)
            
            this.socket.on('connect', (data) => {
                console.log('connect at Time: ' + Date());
                console.log('connect', this.socket.io.engine.transport.name);
                this.listener();
            })
        }
    }

    public isRun() {
        this.ini();
    }

    private listener() {
        this.socket.on("client", (response) => {
            this.response.next(response);
        });
        this.socket.on('connect_timeout', (response) => {

        });
        this.socket.on('connect_error', (response) => {
            console.log('connect_error => Time: ' + Date());
        });
        this.socket.on('disconnect', (response) => {
            console.log(response);
        })
    }

    public send(option: requetsGlobals) {
        if (option.token) {
            if (option.client) {
                let response: responseGlobals = { status: 1, token: option.token, data: option.data, message: null };
                this.response.next(response);
            } else {
                option['authentication'] = this.USERS.info.get();
                this.socket.emit('server', option);
            }
        }
    }

    public time = {
        date: (e) => {
            if (e) {
                e = (typeof e === 'object') ? e : new Date(e);
                return e.getFullYear() + '-' + (e.getMonth() + 1).toString() + '-' + e.getDate();
            }
            return;
        },
        format: (e) => {
            if (e) {
                e = (typeof e === 'object') ? e : new Date(e);
                return e.getDate() + '/' + (e.getMonth() + 1).toString() + '/' + e.getFullYear();
            }
            return;
        },
        convert: (e: any) => {
            if (e) {
                if (typeof e === 'object') {
                    e = (typeof e === 'object') ? e : new Date(e);
                    let m = (e.getMonth() + 1 > 9) ? e.getMonth() + 1 : '0' + (e.getMonth() + 1).toString();
                    let d = e.getDate() > 9 ? e.getDate() : '0' + e.getDate();
                    return parseInt(e.getFullYear() + m.toString() + d);
                } else {
                    try { return +(parseInt(e.split("-").join(""))) } catch (error) { return 0; }
                }
            }
            return 0;
        }
    }

    public USERS = {
        tokenCheckLogin: 'browsersIndexChecklogin',
        checkLogin: () => {
            this.send({ token: this.USERS.tokenCheckLogin, data: this.USERS.info.get() });
        },
        token: {
            key: "userToken",
            set: (token) => {
                window.localStorage.setItem(this.USERS.token.key, token);
            },
            remove: () => {
                window.localStorage.removeItem(this.USERS.token.key);
                this.router.navigate(['/browsers/login']);
            },
            get: () => {
                return window.localStorage.getItem(this.USERS.token.key);
            }
        },
        info: {
            key: "localStorage",
            set: (data) => {
                data = typeof data === 'object' ? JSON.stringify(data) : data;
                window.localStorage.setItem(this.USERS.info.key, data);
            },
            remove: () => {
                window.localStorage.removeItem(this.USERS.info.key);
            },
            get: () => {
                try {
                    if (window.localStorage.getItem(this.USERS.info.key)) {
                        let data = window.localStorage.getItem(this.USERS.info.key);
                        return JSON.parse(data);
                    } else {
                        return {};
                    }

                } catch (error) {
                    return {};
                }

            },
            check: () => {
                return window.localStorage.getItem(this.USERS.info.key) && window.localStorage.getItem(this.USERS.token.key) ? true : false;
            }
        }
    }

    public config = {
        token: {
            help: "configHelpGetrow",
            online: "generalIndexOnline",
            keyboard: "generalIndexKeyboard",
            company: "configWebsiteGet",
            onlineAll: "browsersIndexGetall",
            logout: "browsersIndexLogout"
        },
        help: (id) => {
            this.send({ token: this.config.token.help, params: { id: id } });
        },
        online: () => {
            this.send({ token: this.config.token.online });
        },
        keyboard: () => {
            //this.send({ token: this.config.token.keyboard });
        },
        company: () => {
            this.send({ token: this.config.token.company });
        },
        logout: (id) => {
            this.send({ token: this.config.token.logout, params: { id: id } });
        }
    }

    public formatDigits = {

        encodeNumber: (value) => {
            return value.toString().replace(/[^0-9\.\,]+/g, '').replace(/\,/g, '');
        },

        decodeNumber: (value) => {
            return +((value.toString().replace(/[^0-9\.\,]+/g, '').replace(/\./g, '')).replace(/\,/g, ''));
        },

        decodePrice: (value, isNegative = false) => {
            let regx = isNegative ? /[^0-9\.\,\-]+/g : /[^0-9\.\,]+/g;
            if ((value.toString().match(/,/g) || []).length > 1) {
                value = value.substr(0, value.indexOf(',')) + (value.indexOf(',') > -1 ? ',' : '') + value.substr(value.indexOf(','), value.length).replace(/\,/g, '');
            }
            return +((value.toString().replace(regx, '').replace(/\./g, '')).replace(/\,/g, '.'));
        }
    }

    public crypto = {
        secret: 'chips-salt',
        encrypt: (value) => {
            return encodeURIComponent(CryptoJS.AES.encrypt(value.toString(), this.crypto.secret).toString());
        },
        decrypt: (value) => {
            value = decodeURIComponent(value);
            return CryptoJS.AES.decrypt(value.toString(), this.crypto.secret).toString(CryptoJS.enc.Utf8);
        },
        decryptServer: (v) => {

            let token = 'CkEnNKtOX';

            let e = v.indexOf(token);

            let l = (new Date()).getTime().toString().length;

            let k = v.substr(e + token.length, l);

            let d = v.substr(0, e) + v.substr(e + token.length + l, v.length);

            let p = CryptoJS.AES.decrypt(d, k);

            try {

                return p.toString(CryptoJS.enc.Utf8);

            } catch (err) {
                return {};
            }
        },
        create: (link: string, params: any) => {
            let queryParams = '';
            let key = Object.keys(params);

            for (let i = 0; i < Object.keys(params).length; i++) {
                if (i > 0) { queryParams += '&' };
                queryParams += (key[i] + '=' + this.crypto.encrypt(params[key[i]]));
            }

            let base_url = (this.BASE_API_URL == 'http://localhost:3000/' ? 'http://localhost:4200/' : this.BASE_API_URL);
            return base_url + this.branch_code + link + '?' + queryParams;
        },
        link: (link: string, params: any) => {
            let key = Object.keys(params)
            for (let i = 0; i < Object.keys(params).length; i++) {
                params[key[i]] = this.crypto.encrypt(params[key[i]]);
            }
            this.router.navigate(['/' + this.branch_code + '/' + link], { queryParams: params })
        }
    }

    download(url, filename) {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            })
            .catch(console.error);
    }

    renderToLocaleString = (value, local: string = 'vi-VN', maximumFractionDigits = 3) => {

        value = value || 0;

        return value.toLocaleString(local, { maximumFractionDigits: maximumFractionDigits })
    }
}